/**
 * Video Settings
 *
 * Shared settings type and defaults for video viewers.
 * Used by both screen-stream-viewer and video-panel.
 */

export interface VideoSettings {
	grayscale: boolean
	inverted: boolean
	zoomLevel: number
	zoomLocked: boolean
}

export const DEFAULT_VIDEO_SETTINGS: VideoSettings = {
	grayscale: false,
	inverted: false,
	zoomLevel: 1.0,
	zoomLocked: false,
}

export const VIDEO_SETTINGS_KEY = 'polygraf-stream-viewer-settings'

export function loadVideoSettings(): VideoSettings {
	try {
		const saved = localStorage.getItem(VIDEO_SETTINGS_KEY)
		if (saved) {
			return { ...DEFAULT_VIDEO_SETTINGS, ...JSON.parse(saved) }
		}
	} catch {
		// Ignore parse errors
	}
	return DEFAULT_VIDEO_SETTINGS
}

export function saveVideoSettings(settings: VideoSettings): void {
	try {
		localStorage.setItem(VIDEO_SETTINGS_KEY, JSON.stringify(settings))
	} catch {
		// Ignore storage errors
	}
}
